export var Labels = {
    paymentOptionDivider: 'もしくは'
};
